import { render } from "./MailVerifySignupPage.vue?vue&type=template&id=0e7bc44c"
import script from "./MailVerifySignupPage.vue?vue&type=script&lang=js"
export * from "./MailVerifySignupPage.vue?vue&type=script&lang=js"
script.render = render

export default script